interface Properties {
  width?: number;
  height?: number;
  color?: string;
}

const RefreshIcon = ({ width = 14, height = 14, color = '#708090' }: Properties) => (
  <svg
    width={width}
    height={height}
    viewBox='0 0 16 16'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <path
      d='M13.6537 4.66671C13.0432 3.65926 12.176 2.83112 11.1401 2.26872C10.1042 1.70632 8.93727 1.42978 7.75937 1.4674C6.58146 1.50501 5.43438 1.85541 4.4362 2.48317C3.43803 3.11093 2.62435 3.99354 2.07899 5.04089M1.34635 11.3334C1.9569 12.3408 2.82406 13.169 3.85999 13.7314C4.89593 14.2938 6.06284 14.5703 7.24075 14.5327C8.41865 14.4951 9.56573 14.1447 10.5639 13.5169C11.5621 12.8892 12.3758 12.0066 12.9212 10.9592'
      stroke={color}
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M13.6537 1.83337V4.66671H10.8203'
      stroke={color}
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      d='M1.34644 14.1666V11.3333H4.17977'
      stroke={color}
      strokeWidth='1.3'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default RefreshIcon;
